import { createContext, useState, useEffect } from 'react';
import { onAuthStateChangedListener, createUserDocumentFromAuth } from '../utils/firebase/firebase.utils';

// The actual value to access
export const UserContext = createContext<IUser>({
  currentUser: null,
  displayName: null,
  uid: null
});

interface IUser {
  currentUser?: any;
  displayName?: string | null;
  uid?: any;
}

interface IUserProviderProps {
  children: React.ReactNode;
}

export const UserProvider = ({ children }:IUserProviderProps) => {
  const [currentUser, setCurrentUser] = useState<IUser>(
      {
        currentUser: null,
        uid: null
      }
  );
  const user = { currentUser, setCurrentUser };

  // Only runs once
  // calls onAuthStateChangedListener callback whenever the authentication state of our auth singleton changes
  useEffect(() => {
    // Set the user to the user object if logged in
    // Set it to null if the user is loged out
    const unsubscribe = onAuthStateChangedListener((user:IUser) => {
      setCurrentUser(user);

      if(user) {
        createUserDocumentFromAuth(user)
      }
    });

    return unsubscribe;
  }, []);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}
